import { useFlags } from 'flagsmith/react';

export const useStatusTrackerFeatureFlag = () => {
  const flags = useFlags(['spotlight_status_tracker']);
  return flags.spotlight_status_tracker.enabled;
};

export const useNotificationCenterFeatureFlag = () => {
  const flags = useFlags(['spotlight_notification_center']);
  return flags.spotlight_notification_center.enabled;
};

export const useChangeInvoiceDueDateFeatureFlag = () => {
  const flags = useFlags(['spotlight_change_invoice_due_date']);
  return flags.spotlight_change_invoice_due_date.enabled;
};

export const usePaperBillFeeFlag = () => {
  const flags = useFlags(['new_fees']);

  let allowedStates = [];
  let feeStartDate;

  if (flags.new_fees?.enabled && typeof flags.new_fees?.value === 'string') {
    try {
      const parsed = JSON.parse(flags.new_fees.value);
      allowedStates = (parsed.allowedStates ?? '')
        .split(',')
        .map((v) => v.trim())
        .filter(Boolean);
      feeStartDate = parsed.feeStartDate;
    } catch {
      allowedStates = flags.new_fees.value
        .split(',')
        .map((v) => v.trim())
        .filter(Boolean);
    }
  }

  return {
    enabled: flags.new_fees?.enabled ?? false,
    allowedStates,
    feeStartDate,
  };
};

const HIDE_FLAG_NAMES = [
  'spotlight_hide_site_details_nav',
  'spotlight_hide_site_details_content',
  'spotlight_hide_contacts_nav',
  'spotlight_hide_contacts_content',
  'spotlight_hide_service_contract_nav',
  'spotlight_hide_service_contract_content',
  'spotlight_hide_case_activity_nav',
  'spotlight_hide_case_activity_content',
  'spotlight_hide_system_nav',
  'spotlight_hide_system_content',
  'spotlight_hide_documents_nav',
  'spotlight_hide_documents_content',
  'spotlight_hide_home_energy_report_nav',
  'spotlight_hide_home_energy_report_content',
  'spotlight_hide_install_tracker_nav',
  'spotlight_hide_install_tracker_content',
  'spotlight_hide_notification_center_nav',
  'spotlight_hide_notification_center_content',
];

export const useHideFlags = () => {
  const flags = useFlags(HIDE_FLAG_NAMES);
  return {
    hideSiteDetailsNav: flags.spotlight_hide_site_details_nav?.enabled ?? false,
    hideSiteDetailsContent: flags.spotlight_hide_site_details_content?.enabled ?? false,
    hideContactsNav: flags.spotlight_hide_contacts_nav?.enabled ?? false,
    hideContactsContent: flags.spotlight_hide_contacts_content?.enabled ?? false,
    hideServiceContractNav: flags.spotlight_hide_service_contract_nav?.enabled ?? false,
    hideServiceContractContent: flags.spotlight_hide_service_contract_content?.enabled ?? false,
    hideCaseActivityNav: flags.spotlight_hide_case_activity_nav?.enabled ?? false,
    hideCaseActivityContent: flags.spotlight_hide_case_activity_content?.enabled ?? false,
    hideSystemNav: flags.spotlight_hide_system_nav?.enabled ?? false,
    hideSystemContent: flags.spotlight_hide_system_content?.enabled ?? false,
    hideDocumentsNav: flags.spotlight_hide_documents_nav?.enabled ?? false,
    hideDocumentsContent: flags.spotlight_hide_documents_content?.enabled ?? false,
    hideHomeEnergyReportNav: flags.spotlight_hide_home_energy_report_nav?.enabled ?? false,
    hideHomeEnergyReportContent: flags.spotlight_hide_home_energy_report_content?.enabled ?? false,
    hideInstallTrackerNav: flags.spotlight_hide_install_tracker_nav?.enabled ?? false,
    hideInstallTrackerContent: flags.spotlight_hide_install_tracker_content?.enabled ?? false,
    hideNotificationCenterNav: flags.spotlight_hide_notification_center_nav?.enabled ?? false,
    hideNotificationCenterContent: flags.spotlight_hide_notification_center_content?.enabled ?? false,
  };
};

const DEP_WARN_FLAG_NAMES = [
  'spotlight_dep_warn_site_details',
  'spotlight_dep_warn_contacts',
  'spotlight_dep_warn_service_contract',
  'spotlight_dep_warn_case_activity',
  'spotlight_dep_warn_system',
  'spotlight_dep_warn_documents',
  'spotlight_dep_warn_home_energy_report',
  'spotlight_dep_warn_install_tracker',
  'spotlight_dep_warn_notification_center',
];

export const useDepWarnFlags = () => {
  const flags = useFlags(DEP_WARN_FLAG_NAMES);
  return {
    depWarnSiteDetails: flags.spotlight_dep_warn_site_details?.enabled ?? false,
    depWarnContacts: flags.spotlight_dep_warn_contacts?.enabled ?? false,
    depWarnServiceContract: flags.spotlight_dep_warn_service_contract?.enabled ?? false,
    depWarnCaseActivity: flags.spotlight_dep_warn_case_activity?.enabled ?? false,
    depWarnSystem: flags.spotlight_dep_warn_system?.enabled ?? false,
    depWarnDocuments: flags.spotlight_dep_warn_documents?.enabled ?? false,
    depWarnHomeEnergyReport: flags.spotlight_dep_warn_home_energy_report?.enabled ?? false,
    depWarnInstallTracker: flags.spotlight_dep_warn_install_tracker?.enabled ?? false,
    depWarnNotificationCenter: flags.spotlight_dep_warn_notification_center?.enabled ?? false,
  };
};
